window.addEventListener('variant:changed', function () {
    const addToCartButton = document.querySelector('[data-product-add-to-cart-button-show-price]');
    if (addToCartButton) {
        const priceContainer = document.querySelector('[data-product-price-list]');
        const priceString = priceContainer.innerText.replace('Sale price', '');
        const addToCartButtonCTA = addToCartButton.getAttribute('data-button-cta');
        const addToCartButtonContent = addToCartButton.querySelector('.loader-button__text');
        addToCartButton.setAttribute('data-button-content', addToCartButtonCTA + ' ' + priceString);
        addToCartButtonContent.innerHTML = addToCartButtonCTA + '<span class="square-separator"></span>' + priceString;
    }
});
